import { produce } from 'immer';
import { makeVar } from '@apollo/client';
import { getDraftedUpdater, registerImmerFunctions } from './common';
export function makeImmerVar(initialValue) {
  const reactiveVar = makeVar(initialValue);
  const immerReactiveVar = (...args) => {
    if (args.length === 0) {
      return reactiveVar();
    }
    const [updater] = args;
    const draftedUpdater = getDraftedUpdater(updater, produce);
    const updatedValue = draftedUpdater(reactiveVar());
    return reactiveVar(updatedValue);
  };
  registerImmerFunctions(immerReactiveVar, reactiveVar, initialValue);
  return immerReactiveVar;
}